import { Image } from "@wss/image";
import React from "react";
import LinkTile from "./LinkTile";
const CustomizableSupplies = () => {
  return <div className="bg-gray-50 rounded" data-testid="ways-to-save-customizable" data-sentry-component="CustomizableSupplies" data-sentry-source-file="CustomizableSupplies.tsx">
      <div className="w-full h-auto lg:max-h-40 flex justify-center items-center">
        <a href="/customizable-restaurant-supplies.html" className="relative flex flex-1 justify-center items-center group">
          <span className="absolute z-10 flex flex-col text-center mb-0">
            <span className="text-2xl xsl:text-xl lz:text-2xl font-normal text-white leading-none">
              Add&nbsp;Your&nbsp;Logo
            </span>
            <span className="font-bold text-white leading-none text-4xl xsl:text-3xl lz:text-4xl">
              Customizable
              <br />
              Supplies
            </span>
          </span>
          <Image src="/uploads/design/2022/1/Homepage/customizable_bg@2x.png" alt="" className="relative w-full h-auto rounded-t group-hover:opacity-90 transition-all ease-in-out duration-75 lg:max-h-40" width={20} height={9} data-sentry-element="Image" data-sentry-source-file="CustomizableSupplies.tsx" />
        </a>
      </div>
      <LinkTile link="/customizable-restaurant-supplies.html" linkText="Customizable Supplies" description="Add your logo and make it personal" data-sentry-element="LinkTile" data-sentry-source-file="CustomizableSupplies.tsx" />
    </div>;
};
export default CustomizableSupplies;